import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Presentation = function Presentation(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M22 35H14V25H22V35ZM16 33H20V27H16V33Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M28 35H20V21H28V35ZM22 33H26V23H22V33Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 35H26V17H34V35ZM28 33H32V19H28V33Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M44 41H4V12H6V39H42V12H44V41Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M44 13H4C2.35 13 1 11.65 1 10V8C1 6.35 2.35 5 4 5H44C45.65 5 47 6.35 47 8V10C47 11.65 45.65 13 44 13ZM4 7C3.45 7 3 7.45 3 8V10C3 10.55 3.45 11 4 11H44C44.55 11 45 10.55 45 10V8C45 7.45 44.55 7 44 7H4Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M25 40H23V45H25V40Z",
      fill: color
    })]
  });
};
export default Presentation;